const phoneMin = 320;
const smallMin = 576;
const tabletMin = 768;
const desktopMin = 960;

const getWidth = () => Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

const isGteSm = () => getWidth() >= smallMin;

const isGtePhone = () => getWidth() >= phoneMin;

const isGteTablet = () => getWidth() >= tabletMin;

const isGteDesktop = () => getWidth() >= desktopMin;

export { phoneMin, tabletMin, desktopMin, getWidth, isGtePhone, isGteSm, isGteTablet, isGteDesktop };



// WEBPACK FOOTER //
// ./app/Assets/js/utils/viewport.js